/*
  BIOLIQ — product card "Buy it now".

  Adds the card's selected variant to the cart and sends the customer straight
  to checkout.

  Why not a <form action="/cart/add" return_to="/checkout">: that form was moved
  by script inside Horizon's own product form, so its submit event bubbled up to
  <product-form-component>, whose handleSubmit() calls preventDefault() and does
  an AJAX add-to-cart instead. The customer landed in the cart drawer, never at
  checkout. A plain type="button" with its own fetch cannot be intercepted.
*/
(function () {
  if (window.__bqBuyNow) return;
  window.__bqBuyNow = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* The hidden input is kept in sync by the variant picker, so it beats the
     variant id rendered into the markup at page load. */
  function variantId(card, wrap) {
    var input = card && card.querySelector('product-form-component input[name="id"]');
    if (input && input.value) return input.value;
    return (wrap && wrap.dataset.variantId) || '';
  }

  function quantity(card) {
    var input = card && card.querySelector('.quantity-selector input[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  /* Capture phase on document: runs before the card's own link handlers, so
     stopPropagation() keeps the click from opening the product page. */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('[data-bq-buynow]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.getAttribute('aria-busy') === 'true') return;

      var wrap = button.closest('.bq-buynow');
      var card = button.closest('.product-card');
      var id = variantId(card, wrap);
      if (!id) return;

      var label = button.textContent;
      button.setAttribute('aria-busy', 'true');
      if (button.dataset.busyLabel) button.textContent = button.dataset.busyLabel;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity(card) }] }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
          return response.json();
        })
        .then(function () {
          window.location.href = root + 'checkout';
        })
        .catch(function (error) {
          console.error('[bq-buynow]', error);
          button.setAttribute('aria-busy', 'false');
          button.textContent = label;
        });
    },
    true
  );
})();